export default "__VITE_ASSET__Vv8yYrWo__"